import styled from "styled-components";
import Form from "../Components/Form";
import BannerRecupera from "../Components/BannerRecupera";

export default function Home() {

  return (
    <Container>
        <Banner>
            <img src="/img/banner.png" alt="Banner SPC Escola" />
            <div className="overlay"></div>
            <div className="texto-banner">
                <h1>Reduza a inadimplência da sua escola com segurança e eficácia.</h1>
                <p>SPC Escola: segurança, legalidade e eficiência na gestão financeira.</p>
            </div>
            <div className="logo-banner">
                <img src="/img/spcrio-branco-novo.png" alt="" />
            </div>
        </Banner>
        <BannerRecupera/>
        <Intro>
            <img src="/img/library.png" alt="" />
            <div className="texto-intro">
                <h1>Bem-vindo ao SPC Escola — A Solução Inteligente para Reduzir a Inadimplência Educacional</h1>
                <p>O SPC Escola é uma ferramenta moderna e segura desenvolvida pela Câmara de Dirigentes Lojistas do Rio de Janeiro (CDL Carioca) em parceria com o SPC Brasil, o maior banco de dados de crédito da América Latina. Criado especialmente para instituições de ensino, o sistema permite recuperar créditos e reduzir a inadimplência com agilidade, baixo custo e total respaldo jurídico.</p>
                <p>Muitas escolas e universidades ainda desconhecem que podem registrar débitos em nome do responsável financeiro do aluno, desde que exista contrato de prestação de serviços — sem qualquer constrangimento pedagógico.</p>
                <p>O SPC Escola simplifica esse processo, tornando-o rápido, legal e eficiente.</p>
                <p>Ao aderir, sua instituição passa a contar com uma ampla rede de proteção ao crédito, integrada ao comércio e ao sistema financeiro nacional, além de consultorias, benefícios exclusivos e suporte completo da CDL Carioca.</p>
            </div>
        </Intro>
        <Cards>
            <Card>
                <img src="/img/icon-shield.png" alt="" />
                <div>
                    <h1>SEGURANÇA JURÍDICA</h1>
                    <p>Tenha total respaldo legal para registrar débitos de mensalidades no CPF do responsável financeiro, sem ferir os direitos do aluno.</p>
                </div>
            </Card>
            <Card>
                <img src="/img/icon-computer.png" alt="" />
                <div>
                    <h1>GESTÃO EFICIENTE DE CRÉDITO</h1>
                    <p>Reduza custos e tempo com processos de cobrança. Registre e acompanhe inadimplentes online, de forma rápida e segura.</p>
                </div>
            </Card>
            <Card>
                <img src="/img/icon-handshake.png" alt="" />
                <div>
                    <h1>RECUPERAÇÃO DE RECEITAS</h1>
                    <p>Recupere mensalidades atrasadas com facilidade. O SPC Escola notifica o devedor e estimula o acordo antes de qualquer ação judicial.</p>
                </div>
            </Card>
        </Cards>
        <Lista>
            <img src="/img/img.png" alt="" />
            <ListaItens>
                <h1>POR QUE ESCOLHER O SPC ESCOLA?</h1>
                <p>O SPC Escola é a solução ideal para instituições de ensino que buscam reduzir a inadimplência, recuperar receitas e fortalecer a gestão financeira, com total segurança jurídica e praticidade. Desenvolvido pelo spcrio.com, o sistema oferece eficiência, transparência e resultados reais.</p>
                <ListaItem>
                    <img src="/img/icon-charge.png" alt="" />
                    <div>
                        <h2>Cobrança Legal e Segura</h2>
                        <p>Atue dentro dos limites da lei, sem causar constrangimento pedagógico. Registre débitos de forma segura e juridicamente respaldada no CPF do responsável financeiro.</p>
                    </div>
                </ListaItem>
                <Divisoria></Divisoria>
                <ListaItem>
                    <img src="/img/icon-online.png" alt="" />
                    <div>
                        <h2>Gestão Online e Simplificada</h2>
                        <p>Registre e acompanhe inadimplentes diretamente pela plataforma online do SPC Escola. Notificações automáticas garantem agilidade e reduzem custos com escritórios de cobrança.</p>
                    </div>
                </ListaItem>
                <Divisoria></Divisoria>
                <ListaItem>
                    <img src="/img/icon-result.png" alt="" />
                    <div>
                        <h2>Resultados Comprovados</h2>
                        <p>Mais de 500 instituições já utilizam o SPC Escola no Rio de Janeiro. Aproveite a força do SPC Brasil, o maior banco de dados de crédito da América Latina, e recupere valores com eficiência.</p>
                    </div>
                </ListaItem>
            </ListaItens>
        </Lista>
        <Form />
    </Container>
  );
}

const Container = styled.div`
    overflow-x: hidden;
`;

const Banner = styled.section`
    position: relative; 
    width: 100%;
    overflow: hidden;
    img{
        width: 100%;
        height: auto;
        display: block;
    }
    .overlay{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0; 
        left: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .texto-banner{
        max-width: 40%;
        height: 80%;
        position: absolute;
        top: 5%; 
        left: 5%;
        color: white; 
        font-family: 'poppins', sans-serif;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 50px;
    }
    .logo-banner{
        width: 20%;
        position: absolute;
        top: 6%; 
        right: 2%;
    }
    h1{
        font-size: 30px;
    }
    p{
        font-size: 70px;
        font-weight: bolder;
    }

    @media (max-width: 900px) {
        .texto-banner {
            max-width: 80%;
            top: 10%;
            left: 10%;
            text-align: center;
        }
        .logo-banner {
            display: none;
        }
        h1 {
            font-size: 1.4rem;
        }
        p {
            font-size: 1rem;
        }
    }
`

const Intro = styled.section`
    display: flex;
    justify-content: space-around;
    align-items: center;

    padding: 50px 20px;

    img{
        width: 40%;
        border-radius: 10px;
    }

    .texto-intro{
        height: 100%;
        width: 45%;
        display: flex;
        flex-direction: column;
        gap: 15px;
        font-family: 'poppins', sans-serif;
    }
    h1{
        font-size: 25px;
        font-weight: bolder;
    }
    p{
        font-size: 20px;
    }

    @media (max-width: 900px) {
        width: 100vw;
        flex-direction: column;
        padding: 0;
        img{
            width: 90%;
            border-radius: 10px;
            margin: 25px 0;
        }
        .texto-intro{
            width: 90%;
            display: flex;
            flex-direction: column;
            gap: 15px;
            font-family: 'poppins', sans-serif;
        }
    }
`

const Cards = styled.section`
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 0 20px;
    margin: 20px 0;

    @media (max-width: 900px) {
        width: 100vw;
        flex-direction: column;
        padding: 0;
        gap: 20px;
    }
`
const Card = styled.div`
    width: 30vw;
    max-width: 600px;
    height: 150px;
    font-family: 'poppins', sans-serif;

    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    gap: 20px;
    align-items: center;

    img{
        height: 80%;
    }
    div{
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    h1{
        font-size: 16px;
        font-weight:bold;
    }
    p{
        font-size: 12px;
    }

    @media (max-width: 900px) {
        width: 90%;
    }
`

const Lista = styled.section`
    background-color: #264b91;
    width: 100%;

    display: flex;
    justify-content: space-between;
    align-items: center;

    color: #FFFFFF;
    font-family: 'poppins', sans-serif;

    img{
        width: 50%;
    }
    h1{
        font-size: 25px;
        font-weight: bolder;
    }
    h2{
        font-size: 20px;
        font-weight: bold;
    }
    p{
        font-size: 14px;
    }

    @media (max-width: 900px) {
        width: 100vw;
        flex-direction: column;
        img{
            width: 95%;
            border-radius: 10px;
            margin: 10px;
        }
    }
`
const ListaItens = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 30px;
    padding: 30px;
`
const ListaItem = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    img{
        width: 15%;
    }
    div{
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: center;
    }

    @media (max-width: 900px) {
        width: 100%;
        img{
            width: 25%;
            height: fit-content;
            border-radius: 0;
        }
    }
`
const Divisoria = styled.div`
    width: 100%;
    height: 2px;
    background-color: #faa936;
`
